import { CEMediaAttributesBase } from './ce-media-attributes-base'


export class CEMediaAttributes extends CEMediaAttributesBase {

}